import { ORDER_META_KEY } from "../constants.js";
import { fetchOrdersByCustomerId, } from "./getOrdersByCustomerId.js";
import { getMetaValueFromKey } from "@cappelendamm/crystallize-utils";
export const getOrdersForSubscriptionContract = async ({ contractId, customerId }, { client }) => {
    const orders = await fetchOrdersByCustomerId({ customerId }, { client });
    if (!orders) {
        return [];
    }
    return orders.filter((order) => {
        return (getMetaValueFromKey(order.meta, ORDER_META_KEY.ORDER.SUBSCRIPTION_CONTRACT_ID) === contractId);
    });
};
